export default __webpack_public_path__ + "8971b85666c56af453533d5a3185db11.svg";